module.exports = __webpack_public_path__ + "b926fcd5.jpg";